import CanvasObject from './CanvasObject';

import { roundRect} from './canvas-helper';

import { STOCK_IMAGE } from './itemTypes';

import RedCros from '../../img/red-cross.png';

class OverlayImageItem extends CanvasObject {
	constructor(ctx, image, options = {}) {
		super();
		this.ctx = ctx;
		this.isMetalSkin = options.isMetalSkin;
		this.itemArea = options.itemArea;
		this.selectedValue = false
		this.initialPos = options.initialPosition;
		this.selected = false
		
		this.width = options.width || 50;
		this.height = options.height || 50;

		this.layerType = options.layerType || STOCK_IMAGE;
		// this.type = options.type || IMAGE;
		this.type = options.type || image.activeMode;

		this.id = image.id;
		
		// this.rotation = 90;

		//this.borderColor = options.borderColor || 'rgb(49, 183, 219)';
		this.defaultColor = 'white';

		this.removed = false;

		this.setImage(image.url, this.layerType);

		
		// remove icon (red cross shown when item moved out from allowedArea)
		const removedIcon = new Image();
		removedIcon.src = RedCros;
		removedIcon.onload = () => {
			this.removedIcon = removedIcon;
		};
	}
	setImage(url, imageType) {

		this.layerType = imageType;
		const img = new Image();
		img.crossOrigin = 'Anonymous';
		img.src = url;

		return new Promise(resolve => {
			img.onload = () => {
				this.image = img;
				this.selected = false;
				// Aligning the image at (center) position in Metal skin only
				if(this.initialPos){
					this.originPoint = {
						x: this.initialPos.x,
						y: this.initialPos.y
					};
				}
				this.height =  this.height
				this.width =   this.width 
				resolve(this.image)
			};
		});
	}
	
	render(ctx) {
		if (!this.image) {
			return;
		}

		const { width, height } = ctx.canvas;

		const canvasCenter = {
			x: width / 2,
			y: height / 2
		};

		ctx.save();
		ctx.translate(this.originPoint.x + canvasCenter.x, this.originPoint.y + canvasCenter.y);
		if (this.rotation !== 0) {
			ctx.rotate(this.rotation * Math.PI / 180);
		}


		if (this.flipped) {
			ctx.scale(-1, 1);
		}

		ctx.drawImage(this.image, -this.width / 2, -this.height / 2, this.width, this.height);
	
		ctx.restore();

	}

	
	handleResize(scale) {
		const ratio = this.width / this.height;
		this.width *= scale;
		this.height = this.width / ratio;
		this.originPoint = {
			x: this.originPoint.x * scale,
			y: this.originPoint.y * scale
		}
	}

	preview(scale, ctx) {

		const { width, height } = ctx.canvas;

		const canvasCenter = {
			x: width / 2,
			y: height / 2
		};

		const item = {
			image: this.image,
			width: this.width * scale.width,
			height: this.height * scale.height,
			rotation: this.rotation,
			flipped: this.flipped,
			originPoint: {
				x: this.originPoint.x * scale.width,
				y: this.originPoint.y * scale.height
			}
		};
		
		ctx.save();

		// Commented this as we already translated to 'canvasCenter' in 'this.makeTransparentCoverageRect' function
		//ctx.translate(item.originPoint.x + canvasCenter.x, item.originPoint.y + canvasCenter.y);
		ctx.translate(item.originPoint.x, item.originPoint.y);
		if (item.rotation !== 0) {
			ctx.rotate(item.rotation * Math.PI / 180);
		}

		if (item.flipped) {
			ctx.scale(-1, 1);
		}

		ctx.drawImage(item.image, -item.width / 2, -item.height / 2, item.width, item.height);
		ctx.restore();

	}

}

export default OverlayImageItem;